import React from 'react';
import firebase from 'firebase';
import userStore from '../store/UserStore';
import { TopicCard } from './TopicCard.js';
import logo from '../logo.png';
import '../App.css';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { Tab, Tabs, Button, Alert, Collapse, Tooltip, OverlayTrigger, Label } from 'react-bootstrap';


export default class SkillsPage extends React.Component {

  constructor(props){
    super(props);
    let logged = false;
    if (userStore.authed){
      logged = true;
    }
    this.state = {
      loggedIn: logged,
      users: {},
      uid: userStore.uid,
      user: {name: ''},
      topics: [],
      cats: [],
      newcat: '',
      newcats: [],
      newskill:'',
      catObj:{}
    };
    userStore.registerCallback(this.update.bind(this));

  }

  uiConfig = {
    signInSuccessUrl: '/',
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ]
  }
  componentDidMount(){
    firebase.database().ref(`cats`).on('value', snapshot => {
      let catData = snapshot.val();
      let catArray = [];
      if (!!catData){
        for (var key in catData){
          if (catData.hasOwnProperty(key)) {
              catArray.push({key, name: catData[key]});
          }
        }
        this.setState({
            cats: catArray,
            catObj: catData
        });
        userStore.setGlobal("catObj", catData);
      }
    });
    firebase.database().ref(`skills`).on('value', snapshot => {
            let topicArray = [];
            let topicData = snapshot.val();
            if (!!topicData) {
                for (var key in topicData) {
                    if (topicData.hasOwnProperty(key)) {
                        topicData[key].key = key;
                        topicArray.push(topicData[key]);
                    }
                }
                userStore.setGlobal("topicObj", topicData);
            }
            this.setState({
                topics: topicArray
            });
        });
  }

  update(){
    this.setState({users: userStore.users, loggedIn: userStore.authed});
  }

  removeCat(catid){
    let newcats = this.state.newcats;
    this.setState({
      newcat: '',
      newcats: newcats.filter(x=>x!=catid)
    });
  }

  handleSelect(evt){
    let newcats = this.state.newcats;
    let newcat = evt.target.value;
    newcats.push(newcat);
    this.setState({newcat: evt.target.value, newcats});
  }

  handleSkill(evt){
    this.setState({newskill: evt.target.value});
  }

  handleSubmit(evt){
    if (this.state.newskill == '' || this.state.newcats.length == 0){
      alert("Please fill in skill name and at least one category");
      evt.preventDefault();
      return;
    }
    let catObj = {}
    var i;
    for (i=0; i < this.state.newcats.length; i++){
      catObj[this.state.newcats[i]] = this.state.catObj[this.state.newcats[i]];
    }
    let topic={
      name: this.state.newskill,
      cats: catObj
    };
    console.log(topic);
    let newRef = firebase.database().ref(`skills`).push();
    newRef.set(topic).then(()=>{
      this.setState({newskill:'',newcats:[],newcat:''});
    });
    evt.preventDefault();
  }

  render() {

    let topicArray = this.state.topics;
    let catArray = this.state.cats;

    return (
      <div className="App">
          <header className="App-header">
            <h1>UD CTF Skills</h1>
            <div className="App-title">{!!userStore.authed && <span>{userStore.displayName}</span>}</div>
          </header>
          {!this.state.loggedIn && <div>
              <p>Please sign-in:</p>
              <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()}/>
          </div>}
          <section>
            {topicArray.map(topic=>{
              return (<TopicCard topic={topic} user={this.state.user} key={topic.key} />);
            })}
          </section>
          <hr/>
          <section>
            {this.state.loggedIn &&
            <form onSubmit={this.handleSubmit.bind(this)}>
              <h3>Add New Skill</h3>
              <h4>Name The Skill:</h4>
              <input type="text" value={this.state.newskill} onChange={this.handleSkill.bind(this)} placeholder="skill name here"/>
              <h4>What Categories (click to remove)?</h4>
              <h5>{this.state.newcats.map(catid=>{
                return (<Label onClick={this.removeCat.bind(this, catid)}>{this.state.catObj[catid]} X </Label>);
              })}</h5>
              <select value={this.state.newcat} onChange={this.handleSelect.bind(this)}>
                <option value=''>--Add Category--</option>
                {
                  catArray.map(cat=>{
                    return (<option value={cat.key} key={cat.key}>{cat.name}</option>);
                  })
                }
              </select>
              <hr/>
              <button type="submit">Submit New Skill</button>
            </form>
            }
          </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SkillsPage.js